var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 31.25",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20.5,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 5.03c.73.05 1.1.17 1.47.37.48.26.87.65 1.13 1.13.26.5.4.98.4 2.32v12.3c0 1.34-.14 1.83-.4 2.32a2.8 2.8 0 0 1-1.13 1.13c-.5.26-.98.4-2.32.4H8.85c-1.34 0-1.83-.14-2.32-.4a2.73 2.73 0 0 1-1.13-1.13c-.2-.37-.32-.74-.37-1.47h12.84c1.79 0 2.43-.19 3.08-.53a3.63 3.63 0 0 0 1.52-1.52c.34-.65.53-1.3.53-3.08V5.03z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaCarousel);
export default __webpack_public_path__ + "static/media/InstaCarousel.8ce7aebe491ff07dcd015f1b4d891411.svg";
export { ForwardRef as ReactComponent };